import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import HazardTooltip from './HazardTooltip';

/**
 * The storm tooltip, docked flush against the left border of the map and centred on its height (a bottom sheet
 * on phones). It lives outside the MapContainer, so map clicks never see it. X, Esc and a click on the map close it
 * (the caller deselects the storm); `rootRef` lets the map measure the space it covers so fits can frame the storm
 * in the free area.
 */
export default function HazardCard({ event, isDark, detail, onClose, rootRef }) {
  const { t } = useTranslation();
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeRef.current?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return (
    <aside
      ref={rootRef}
      className={`absolute z-[950] overflow-y-auto border shadow-xl
        sm:left-0 sm:top-1/2 sm:w-[288px] sm:-translate-y-1/2 sm:max-h-[calc(100%-192px)] sm:min-h-[120px] sm:rounded-r-xl sm:border-l-0
        max-sm:inset-x-0 max-sm:bottom-0 max-sm:max-h-[40%] max-sm:rounded-t-xl max-sm:border-b-0 ${
        isDark ? 'border-[#333] bg-[#1d1d1d] text-gray-200' : 'border-[#e5e7eb] bg-white text-[#1f2937]'
      }`}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label={t('map.hazard.close', 'Close storm details')}
        className={`absolute right-1.5 top-1.5 z-10 rounded p-1.5 ${isDark ? 'text-gray-300 hover:bg-[#333]' : 'text-gray-500 hover:bg-gray-100'}`}
      >
        <X size={16} />
      </button>
      <div className="px-3 py-3 pr-9">
        <HazardTooltip event={event} isDark={isDark} detail={detail} />
      </div>
    </aside>
  );
}
